import { render, staticRenderFns } from "./innovacion.vue?vue&type=template&id=55ba576a"
import script from "./innovacion.vue?vue&type=script&lang=js"
export * from "./innovacion.vue?vue&type=script&lang=js"
import style0 from "./innovacion.vue?vue&type=style&index=0&id=55ba576a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports